import { Alert, Icons, Typography } from '@cast/design-system';

export const HpaLegacyCompleteSetupBanner = () => {
  return (
    <Alert
      testId="hpa-legacy-complete-setup-banner"
      size="sm"
      variant="filled"
      color="advisory"
      icon={<Icons.XCircle size={20} />}
      title="Complete the setup shown in the banner to continue"
    >
      <Typography variant="P12R">
        Enable policy-based horizontal scaling for compatible workloads in
        policies. Workloads managed through annotations must be configured
        manually .
      </Typography>
    </Alert>
  );
};
